import Api from '@/services/Api'

export default {
  index () {
    return Api().get('rolePermission')
  }
}



// WEBPACK FOOTER //
// ./src/services/RolePermissionService.js